var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShowcase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 90,
    viewBox: "0 0 74 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1439_545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9114 17.6751C14.835 15.5192 16.482 13.691 18.6342 13.5429L59.6979 10.7157C62.0097 10.5565 63.9727 12.389 63.9727 14.7062V78.0266C63.9727 80.2357 62.1818 82.0266 59.9727 82.0266H21.0528C18.8988 82.0266 17.1316 80.3209 17.0553 78.1683L14.9114 17.6751Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 80.0625V80.0625C17.7908 80.2304 16.6977 79.3255 16.637 78.1062L13.6677 18.5M63.75 18.5L63.5361 15.3147M13.6677 18.5L13.5739 16.6186C13.4641 14.4127 15.1627 12.5353 17.3685 12.4246L59.2596 10.3221C61.4396 10.2127 63.3048 11.8712 63.4511 14.0491L63.5361 15.3147M13.6677 18.5L63.5361 15.3147",
    stroke: "#333333",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.977 25.4595C22.977 23.5817 24.4992 22.0595 26.377 22.0595H69.3569C71.2347 22.0595 72.7569 23.5817 72.7569 25.4595V28.5002V85.9681C72.7569 87.8459 71.2347 89.3681 69.3569 89.3681H26.377C24.4992 89.3681 22.977 87.8459 22.977 85.9681V28.5002V25.4595Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9876 25.614H43.9615C43.8164 25.614 43.6992 25.4077 43.6992 25.1522C43.6992 24.8967 43.8164 24.6904 43.9615 24.6904H53.9876C54.1327 24.6904 54.2498 24.8967 54.2498 25.1522C54.2498 25.4077 54.1327 25.614 53.9876 25.614Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.625 66.75L1.69149 11.2154C1.37875 9.02628 2.90164 6.99876 5.0912 6.68912L46.6447 0.812865C48.8398 0.502455 50.8686 2.03645 51.1681 4.23301L51.375 5.75",
    stroke: "#333333",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6294 19.0288C17.5476 16.8629 19.2058 15.0259 21.3687 14.8862L65.6581 12.0251C67.9639 11.8761 69.916 13.7061 69.916 16.0167V79.3552C69.916 81.5644 68.1252 83.3552 65.916 83.3552H23.9109C21.7605 83.3552 19.9949 81.6551 19.9137 79.5062L17.6294 19.0288Z",
    fill: "#98A9FF",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.835 38.8262H33.3838V39.7341H46.835V38.8262Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9381 42.7964H33.3839V43.7044H42.9381V42.7964Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2985 51.4766H33.3839V52.3845H42.2985V51.4766Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.094 64.9894H33.3839V65.8974H48.094V64.9894Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.094 68.7623H33.3839V69.6703H48.094V68.7623Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8351 78.1617H33.3839V79.0697H46.8351V78.1617Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4748 55.4468H33.3839V56.3547H47.4748V55.4468Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9105 66.4302C58.7699 66.4302 58.6361 66.3644 58.5499 66.2509L56.1817 63.1343C56.0298 62.9345 56.0683 62.6508 56.2679 62.4987C56.4676 62.3466 56.7511 62.3852 56.9031 62.5849L58.906 65.2226L64.6798 58.0673C64.8295 57.8676 65.113 57.8244 65.3149 57.9743C65.5145 58.1241 65.5576 58.4101 65.4056 58.6098L59.2712 66.2463C59.185 66.3598 59.0512 66.4279 58.9105 66.4279V66.4302Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9105 78.1166C58.7699 78.1166 58.6361 78.0508 58.5499 77.9373L56.1817 74.8207C56.0298 74.6209 56.0683 74.3372 56.2679 74.1851C56.4676 74.033 56.7511 74.0716 56.9031 74.2714L58.906 76.909L64.0986 70.2026C64.2483 70.0028 64.5319 69.9597 64.7338 70.1095C64.9334 70.2593 64.9765 70.5453 64.8245 70.7451L59.2712 77.9328C59.185 78.0463 59.0512 78.1144 58.9105 78.1144V78.1166Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2466 39.7344C54.4514 39.7344 51.375 42.8108 51.375 46.606C51.375 50.4012 54.4514 53.4777 58.2466 53.4777C62.0419 53.4777 65.1183 50.4012 65.1183 46.606C65.1183 42.8108 62.0419 39.7344 58.2466 39.7344ZM58.246 42.828C58.4501 42.828 58.6353 42.9481 58.7177 43.1346L61.2946 48.9722C61.41 49.233 61.292 49.5372 61.0315 49.652C60.9642 49.6818 60.8936 49.6956 60.8242 49.6956C60.6263 49.6956 60.4373 49.581 60.3524 49.3882L59.8773 48.3125C59.8498 48.317 59.8216 48.3212 59.7928 48.3212H56.7005C56.6717 48.3212 56.6438 48.3173 56.616 48.3125L56.1409 49.3882C56.0264 49.6487 55.7215 49.7664 55.4617 49.6513C55.2013 49.5365 55.0829 49.2326 55.198 48.9722L57.7749 43.1346C57.8573 42.9481 58.0419 42.828 58.246 42.828ZM58.2466 44.6197L57.0676 47.2905H59.4257L58.2466 44.6197Z",
    fill: "#32BEB0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.915,
    y: 60.5078,
    width: 7,
    height: 7,
    rx: 0.5,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.915,
    y: 72.1943,
    width: 7,
    height: 7,
    rx: 0.5,
    stroke: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1439_545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72.7141,
    height: 89.9359,
    fill: "white",
    transform: "translate(0.642578 0.0322266)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowcase);
export default __webpack_public_path__ + "static/media/showcase.8f82f4a2ac55c57f11b9e8342608ab3c.svg";
export { ForwardRef as ReactComponent };